export type Testimonial = {
  id: string;
  author: string;
  short: string;
  quote: string;
};

export const testimonials: Testimonial[] = [
  {
    id: 'valerie',
    author: 'Valérie Bernolin',
    short: 'À la hauteur de mes exigences',
    quote:
      'Produit à l’aloe vera à la hauteur de mes exigences. J’ai eu le plaisir de tester le gel, qui contient 98 % d’aloe vera Bio, originaire d’Espagne où elle est cultivée dans les meilleures conditions naturelles. Il ne s’agit pas d’aloe vera déshydraté. On en ressent les bienfaits immédiatement.',
  },
  {
    id: 'manon',
    author: 'Manon Genevrière',
    short: 'Effet frais assuré',
    quote:
      'J’utilise le gel aloesol sur mon visage et pour prévenir les vergetures liées à la grossesse. Le gel pénètre facilement, effet frais assuré et hydratation immédiate ! Je recommande ce produit naturel !',
  },
  {
    id: 'yvanna',
    author: 'Yvanna Marzin',
    short: 'Je l’applique tous les jours',
    quote:
      'J’ai testé le gel à l’aloe vera et depuis je l’applique pratiquement tous les jours. Idéal pour le visage, cicatrices et cheveux. Fraîche et hydratante, sa texture gel s’applique très bien. Le format 100 ml est parfait pour le mettre dans une trousse et l’amener partout.',
  },
  {
    id: 'cliente',
    author: 'Une cliente fidèle',
    short: 'Mon allié de l’été',
    quote:
      'J’utilise la gamme ALOESOL au quotidien. Le gel Aloé est mon allié durant tout l’été pour apaiser coup de soleil, brûlures, petits soucis de peau. La crème mains et pieds m’accompagne toute l’année. Je suis bluffée par le pouvoir hydratant de ces crèmes.',
  },
  {
    id: 'fanny',
    author: 'Fanny Gillet',
    short: 'Une odeur addictive',
    quote:
      'Produits très agréables à utiliser (y compris le savon et son odeur addictive). La démarche responsable de la marque est également un vrai plus pour moi.',
  },
  {
    id: 'hind',
    author: 'Hind Ait-Ahmad',
    short: 'Une démarche éco-responsable',
    quote: 'Des produits de qualité avec une démarche éco-responsable. C’est un réel plus !',
  },
];
